import React from "react";
import { Link } from "react-router-dom";
import { Box, Container, Grid, Typography, IconButton } from "@mui/material";
import { BsInstagram, BsYoutube } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";
import seoConfig from "../../config/seo/seoConfig";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <Box
      className="footer-wrapper"
      component="footer"
      sx={{
        backgroundColor: '#1B422E',
        color: '#fff',
        py: { xs: 4, md: 5 },
        mt: 'auto'
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Info */}
          <Grid item xs={12} md={4}>
            <Typography
              variant="h3"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '1.5rem',
                fontWeight: 700,
                mb: 2,
                color: '#C5F0C2'
              }}
            >
              {seoConfig.company.name}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '0.95rem',
                lineHeight: 1.6,
                color: '#e8e8e8',
                mb: 2
              }}
            >
              {seoConfig.company.shortDescription}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '0.9rem',
                color: '#c5c5c5'
              }}
            >
              📍 {seoConfig.company.address}
            </Typography>
          </Grid>

          {/* Navigation Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '1.1rem',
                fontWeight: 600,
                mb: 2,
                color: '#FE9E0D'
              }}
            >
              Navegação
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Link
                to="/"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Home
              </Link>
              <Link
                to="/hortalicas"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Hortaliças
              </Link>
              <Link
                to="/loja-online"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Loja Online
              </Link>
              <Link
                to="/morangos"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Morangos
              </Link>
              <Link
                to="/turismo"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Turismo Rural
              </Link>
              <Link
                to="/sobre"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Sobre Nós
              </Link>
            </Box>
          </Grid>

          {/* External Links */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '1.1rem',
                fontWeight: 600,
                mb: 2,
                color: '#FE9E0D'
              }}
            >
              Links Úteis
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <a
                href={seoConfig.externalLinks.loja}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Loja Virtual
              </a>
              <a
                href={seoConfig.externalLinks.tracking}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Rastreamento
              </a>
              <a
                href={seoConfig.externalLinks.blog}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  color: '#e8e8e8',
                  textDecoration: 'none',
                  fontFamily: '"Reem Kufi", sans-serif',
                  fontSize: '0.95rem',
                  transition: 'color 0.2s'
                }}
                onMouseEnter={(e) => (e.target.style.color = '#C5F0C2')}
                onMouseLeave={(e) => (e.target.style.color = '#e8e8e8')}
              >
                Blog & Receitas
              </a>
            </Box>
          </Grid>

          {/* Social Media */}
          <Grid item xs={12} md={2}>
            <Typography
              variant="h4"
              sx={{
                fontFamily: '"Reem Kufi", sans-serif',
                fontSize: '1.1rem',
                fontWeight: 600,
                mb: 2,
                color: '#FE9E0D'
              }}
            >
              Redes Sociais
            </Typography>
            <Box sx={{ display: 'flex', gap: 1.5 }}>
              <IconButton
                onClick={() => window.open(seoConfig.company.socialLinks.instagram, "_blank")}
                sx={{
                  color: '#e8e8e8',
                  '&:hover': {
                    color: '#C5F0C2',
                    backgroundColor: 'rgba(197, 240, 194, 0.1)'
                  }
                }}
                aria-label="Instagram"
              >
                <BsInstagram size={24} />
              </IconButton>
              <IconButton
                onClick={() => window.open(seoConfig.company.socialLinks.youtube, "_blank")}
                sx={{
                  color: '#e8e8e8',
                  '&:hover': {
                    color: '#C5F0C2',
                    backgroundColor: 'rgba(197, 240, 194, 0.1)'
                  }
                }}
                aria-label="YouTube"
              >
                <BsYoutube size={24} />
              </IconButton>
              <IconButton
                onClick={() => window.open(seoConfig.company.socialLinks.facebook, "_blank")}
                sx={{
                  color: '#e8e8e8',
                  '&:hover': {
                    color: '#C5F0C2',
                    backgroundColor: 'rgba(197, 240, 194, 0.1)'
                  }
                }}
                aria-label="Facebook"
              >
                <FaFacebookF size={22} />
              </IconButton>
            </Box>
          </Grid>
        </Grid>

        {/* Copyright */}
        <Box
          sx={{
            borderTop: '1px solid rgba(197, 240, 194, 0.2)',
            mt: 4,
            pt: 3,
            textAlign: 'center'
          }}
        >
          <Typography
            variant="body2"
            sx={{
              fontFamily: '"Reem Kufi", sans-serif',
              fontSize: '0.9rem',
              color: '#c5c5c5'
            }}
          >
            © {currentYear} {seoConfig.company.name}. Todos os direitos reservados.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
